module.exports = __webpack_public_path__ + "SamsungOne-700.b276f96348dd7df39996.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-700.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-700.ttf
// module chunks = styles